// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as $$String from "../../../../../../../../../node_modules/rescript/lib/es6/string.js";
import * as Nanoid from "nanoid";
import * as ReactModal from "react-modal";
import * as Row$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as CountryContext from "../../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as ConfirmationModal from "../ConfirmationModal.bs.js";
import * as CorePricingActions from "../../../vm-mapper/CorePricingActions.bs.js";
import * as CorePricingContext from "../../../library/core-pricing-context/CorePricingContext.bs.js";
import * as MuiLoader$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/MuiLoader.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as PrimaryButton$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/PrimaryButton.bs.js";
import * as ReasonReactUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ReasonReactUtils.bs.js";
import * as PricingDashboardRepoManager from "../../../../../app/PricingDashboardRepoManager.bs.js";
import * as PricingDashboardAssetsManager from "../../../../assets/PricingDashboardAssetsManager.bs.js";

var error_sign = PricingDashboardAssetsManager.getImage("error-sign.svg");

function CorePricingDetailsFooter$ActionConfirmationModal(Props) {
  var action = Props.action;
  var onConfirmCb = Props.onConfirmCb;
  var onCancelCb = Props.onCancelCb;
  var campaign_name = Props.campaign_name;
  var action_string = CorePricingActions.toString(action);
  return React.createElement(ConfirmationModal.make, {
              title: action_string + " Campaign",
              isOpen: true,
              onConfirmCb: onConfirmCb,
              onCancelCb: onCancelCb,
              confirm_button_title: "Yes, " + action_string,
              cancel_button_title: "No, Cancel",
              children: React.createElement("p", undefined, "You are about to " + ($$String.lowercase_ascii(action_string) + " "), React.createElement("b", undefined, campaign_name), " campaign. Are you sure you wish to continue?")
            });
}

var ActionConfirmationModal = {
  make: CorePricingDetailsFooter$ActionConfirmationModal
};

var modal_close_cross = PricingDashboardAssetsManager.getImage("modal-close.svg");

function CorePricingDetailsFooter$CampaignConflictModal(Props) {
  var msg = Props.msg;
  var closeModal = Props.closeModal;
  return React.createElement(ReactModal, {
              isOpen: true,
              onRequestClose: (function (param) {
                  
                }),
              overlayClassName: "modal-overlay",
              className: "modal-content",
              ariaHideApp: false,
              shouldCloseOnOverlayClick: false,
              children: React.createElement("div", {
                    className: "c-conflicting-campaign-modal"
                  }, React.createElement("div", {
                        className: "title-bar"
                      }, React.createElement("div", {
                            className: "title"
                          }, "Campaign Conflict"), React.createElement("div", {
                            className: "close-btn",
                            onClick: (function (param) {
                                return Curry._1(closeModal, undefined);
                              })
                          }, React.createElement("img", {
                                src: modal_close_cross
                              }))), React.createElement("div", {
                        className: "body"
                      }, msg), React.createElement("div", {
                        className: "footer"
                      }, React.createElement(PrimaryButton$Catalyst.make, {
                            buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                                  TAG: /* Text */0,
                                  _0: "Okay"
                                }, undefined, (function (param) {
                                    return Curry._1(closeModal, undefined);
                                  }), undefined, undefined, undefined, undefined, "c-mui-primary-next-btn", undefined, undefined)
                          })))
            });
}

var CampaignConflictModal = {
  modal_close_cross: modal_close_cross,
  make: CorePricingDetailsFooter$CampaignConflictModal
};

function approveCampaign(campaign_id, onSuccessCb, onFailureCb, country) {
  var RepoInstance = PricingDashboardRepoManager.getPricingRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.approveCampaign, campaign_id, country);
              }), (function (_data) {
                return Curry._1(onSuccessCb, undefined);
              }), Curry.__1(onFailureCb));
}

function deleteCampaign(campaign_id, onSuccessCb, onFailureCb, country) {
  var RepoInstance = PricingDashboardRepoManager.getPricingRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.deleteCampaign, campaign_id, country);
              }), (function (_data) {
                return Curry._1(onSuccessCb, undefined);
              }), Curry.__1(onFailureCb));
}

function discardCampaign(campaign_id, onSuccessCb, onFailureCb, country) {
  var RepoInstance = PricingDashboardRepoManager.getPricingRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.discardCampaign, campaign_id, country);
              }), (function (_data) {
                return Curry._1(onSuccessCb, undefined);
              }), Curry.__1(onFailureCb));
}

function getActionCb(action, set_footer_state, setActiveTab, campaign_id, campaign_name, openSnackbar, refetch_core_pricings, closeSidebar, closeConfirmationModal, openConflictingCampaignModal, country) {
  switch (action) {
    case /* Approve */0 :
        return function (param) {
          Curry._1(closeConfirmationModal, undefined);
          Curry._1(set_footer_state, (function (param) {
                  return {
                          TAG: /* Submitting */0,
                          _0: /* Approve */0
                        };
                }));
          return approveCampaign(campaign_id, (function (param) {
                        Curry._1(openSnackbar, {
                              TAG: /* Success */0,
                              _0: campaign_name + " Campaign has been successfully approved."
                            });
                        Curry._1(setActiveTab, /* Scheduled */1);
                        Curry._1(refetch_core_pricings, undefined);
                        return Curry._1(closeSidebar, undefined);
                      }), (function (err) {
                        var payload = err._0;
                        var match = payload.title;
                        if (match === 4) {
                          Curry._1(set_footer_state, (function (param) {
                                  return /* Init */0;
                                }));
                          return Curry._1(openConflictingCampaignModal, payload.message);
                        } else {
                          return Curry._1(set_footer_state, (function (param) {
                                        return {
                                                TAG: /* Error */1,
                                                _0: err
                                              };
                                      }));
                        }
                      }), country);
        };
    case /* Discard */1 :
        return function (param) {
          Curry._1(closeConfirmationModal, undefined);
          Curry._1(set_footer_state, (function (param) {
                  return {
                          TAG: /* Submitting */0,
                          _0: /* Discard */1
                        };
                }));
          return discardCampaign(campaign_id, (function (param) {
                        Curry._1(openSnackbar, {
                              TAG: /* Success */0,
                              _0: campaign_name + " Campaign has been successfully discarded."
                            });
                        Curry._1(refetch_core_pricings, undefined);
                        return Curry._1(closeSidebar, undefined);
                      }), (function (err) {
                        return Curry._1(set_footer_state, (function (param) {
                                      return {
                                              TAG: /* Error */1,
                                              _0: err
                                            };
                                    }));
                      }), country);
        };
    case /* Delete */2 :
        return function (param) {
          Curry._1(closeConfirmationModal, undefined);
          Curry._1(set_footer_state, (function (param) {
                  return {
                          TAG: /* Submitting */0,
                          _0: /* Delete */2
                        };
                }));
          return deleteCampaign(campaign_id, (function (param) {
                        Curry._1(openSnackbar, {
                              TAG: /* Success */0,
                              _0: campaign_name + " Campaign has been successfully deleted."
                            });
                        Curry._1(refetch_core_pricings, undefined);
                        return Curry._1(closeSidebar, undefined);
                      }), (function (err) {
                        return Curry._1(set_footer_state, (function (param) {
                                      return {
                                              TAG: /* Error */1,
                                              _0: err
                                            };
                                    }));
                      }), country);
        };
    
  }
}

function getActionBtns(actions, toggleConfirmationModal) {
  return ReasonReactUtils$Catalyst.listToReactArray(List.map((function (action) {
                    switch (action) {
                      case /* Approve */0 :
                          return React.createElement(PrimaryButton$Catalyst.make, {
                                      buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                                            TAG: /* Text */0,
                                            _0: "Approve"
                                          }, undefined, (function (param) {
                                              return Curry._1(toggleConfirmationModal, /* Approve */0);
                                            }), undefined, undefined, undefined, undefined, "c-mui-primary-next-btn", undefined, undefined),
                                      key: Nanoid.nanoid()
                                    });
                      case /* Discard */1 :
                          return React.createElement(PrimaryButton$Catalyst.make, {
                                      buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                                            TAG: /* Text */0,
                                            _0: "Discard"
                                          }, undefined, (function (param) {
                                              return Curry._1(toggleConfirmationModal, /* Discard */1);
                                            }), undefined, undefined, undefined, undefined, "c-mui-primary-back-btn", undefined, undefined),
                                      key: Nanoid.nanoid()
                                    });
                      case /* Delete */2 :
                          return React.createElement(PrimaryButton$Catalyst.make, {
                                      buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                                            TAG: /* Text */0,
                                            _0: "Delete"
                                          }, undefined, (function (param) {
                                              return Curry._1(toggleConfirmationModal, /* Delete */2);
                                            }), undefined, undefined, undefined, undefined, "c-mui-primary-next-btn", undefined, undefined),
                                      key: Nanoid.nanoid()
                                    });
                      
                    }
                  }), actions));
}

function getErrorString(err) {
  return err._0.message;
}

function CorePricingDetailsFooter(Props) {
  var actions = Props.actions;
  var campaign_id = Props.campaign_id;
  var campaign_name = Props.campaign_name;
  var closeSidebar = Props.closeSidebar;
  var match = CountryContext.useContext(undefined);
  var match$1 = React.useState(function () {
        return /* Init */0;
      });
  var footer_state = match$1[0];
  var match$2 = CorePricingContext.useContext(undefined);
  var setActiveTab = match$2.setActiveTab;
  var match$3 = React.useState(function () {
        
      });
  var toggleConfirmationModal = match$3[1];
  var action = match$3[0];
  var match$4 = React.useState(function () {
        return [
                false,
                undefined
              ];
      });
  var toggleConflictingCampaignModal = match$4[1];
  var match$5 = match$4[0];
  var message = match$5[1];
  if (!actions) {
    return null;
  }
  var tmp;
  if (typeof footer_state === "number") {
    tmp = getActionBtns(actions, (function (action) {
            return Curry._1(toggleConfirmationModal, (function (param) {
                          return action;
                        }));
          }));
  } else if (footer_state.TAG === /* Submitting */0) {
    var tmp$1;
    switch (footer_state._0) {
      case /* Approve */0 :
          tmp$1 = React.createElement("div", undefined, "Approving Campaign");
          break;
      case /* Discard */1 :
          tmp$1 = React.createElement("div", undefined, "Discarding Campaign");
          break;
      case /* Delete */2 :
          tmp$1 = React.createElement("div", undefined, "Deleting Campaign");
          break;
      
    }
    tmp = React.createElement(Row$Catalyst.make, {
          children: null,
          className: "submitting-action"
        }, React.createElement(MuiLoader$Catalyst.make, {}), tmp$1);
  } else {
    tmp = React.createElement(React.Fragment, undefined, React.createElement(Row$Catalyst.make, {
              children: null,
              className: "error-message-container"
            }, React.createElement("img", {
                  src: error_sign
                }), footer_state._0._0.message), getActionBtns(actions, (function (action) {
                return Curry._1(toggleConfirmationModal, (function (param) {
                              return action;
                            }));
              })));
  }
  return React.createElement("div", {
              className: "c-campaign-details-footer"
            }, tmp, action !== undefined ? React.createElement(CorePricingDetailsFooter$ActionConfirmationModal, {
                    action: action,
                    onConfirmCb: getActionCb(action, match$1[1], (function (tab) {
                            return Curry._1(setActiveTab, (function (param) {
                                          return tab;
                                        }));
                          }), campaign_id, campaign_name, match$2.openSnackbar, match$2.refetch_core_pricings, closeSidebar, (function (param) {
                            return Curry._1(toggleConfirmationModal, (function (param) {
                                          
                                        }));
                          }), (function (msg) {
                            return Curry._1(toggleConflictingCampaignModal, (function (param) {
                                          return [
                                                  true,
                                                  msg
                                                ];
                                        }));
                          }), match.country),
                    onCancelCb: (function (param) {
                        return Curry._1(toggleConfirmationModal, (function (param) {
                                      
                                    }));
                      }),
                    campaign_name: campaign_name
                  }) : null, match$5[0] && message !== undefined ? React.createElement(CorePricingDetailsFooter$CampaignConflictModal, {
                    msg: message,
                    closeModal: (function (param) {
                        return Curry._1(toggleConflictingCampaignModal, (function (param) {
                                      return [
                                              false,
                                              undefined
                                            ];
                                    }));
                      })
                  }) : null);
}

var make = CorePricingDetailsFooter;

export {
  error_sign ,
  ActionConfirmationModal ,
  CampaignConflictModal ,
  approveCampaign ,
  deleteCampaign ,
  discardCampaign ,
  getActionCb ,
  getActionBtns ,
  getErrorString ,
  make ,
  
}
/* error_sign Not a pure module */
